import React from 'react'
import { useTranslation } from 'react-i18next'
import { Bell } from 'lucide-react'
import { useScanPanel } from '../contexts/ScanPanelContext'

/**
 * Bell icon for the navbar. Shows a red badge with the unread scan count.
 * Click reopens the ScanPanel at index 0.
 */
export default function NotificationBell() {
  const { t } = useTranslation()
  const { unreadCount, scans, reopenPanel } = useScanPanel()
  const disabled = scans.length === 0

  return (
    <button
      type="button"
      onClick={reopenPanel}
      disabled={disabled}
      className="relative p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-30 disabled:cursor-not-allowed"
      aria-label={
        unreadCount > 0
          ? t('scanPanel.bell.unreadLabel', { count: unreadCount })
          : t('scanPanel.bell.noRecentLabel')
      }
      title={t('scanPanel.bell.title')}
    >
      <Bell className="w-5 h-5 text-gray-600 dark:text-gray-300" />
      {unreadCount > 0 && (
        <span className="absolute top-0 right-0 -mt-0.5 -mr-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 text-[10px] font-bold leading-none text-white bg-red-600 rounded-full">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  )
}
